import {
  parse,
  format,
  fromUnixTime,
  getISODay,
  differenceInYears,
  differenceInMonths,
  differenceInDays,
  differenceInMilliseconds,
} from 'date-fns';
import { ru } from 'date-fns/locale';

/**
 * Получить дату нужного формата из Date
 * @param {Date|number} date
 * @param {string} expectedFormat
 * @returns {string}
 */
export const getFormatDateTime = (date, expectedFormat) => format(
  date,
  expectedFormat,
  { locale: ru },
);

/**
 * Получить Date из строки
 * @param {string} date
 * @param {string} [originalFormat='dd.MM.yyyy']
 * @returns {Date|*}
 */
export const parseDateOfString = (date, originalFormat = 'dd.MM.yyyy') => parse(date, originalFormat, new Date());

/**
 * Получить Date из unix timestamp
 * @param {number} date
 * @returns {Date|*}
 */
export const parseDateOfUnixTime = date => fromUnixTime(date);

/**
 * Получить дату в нужном фромате из исходной строки
 * @param {string} date
 * @param {string} [originalFormat='dd.MM.yyyy']
 * @param {string} [expectedFormat='d MMMM yyyy']
 * @returns {string|*}
 */
export const getDateTimeOfString = (date, expectedFormat = 'd MMMM yyyy', originalFormat = 'dd.MM.yyyy') => format(parseDateOfString(date, originalFormat), expectedFormat, { locale: ru });

/**
 * Получить дату в нужном формате из unix timestamp
 * @param {number} date
 * @param {string} [expectedFormat='d MMMM yyyy']
 * @returns {string}
 */
export const getDateTimeOfUnixTime = (date, expectedFormat = 'd MMMM yyyy') => format(parseDateOfUnixTime(date), expectedFormat, { locale: ru });

/**
 * Получить ISO номер дня недели
 * @param {string|number} date
 * @param {string} [originalFormat='dd.MM.yyyy']
 * @returns {number}
 */
export const getDayNumber = (date, originalFormat = 'dd.MM.yyyy') => {
  if (typeof date === 'number') {
    return getISODay(parseDateOfUnixTime(date));
  }
  return getISODay(parseDateOfString(date, originalFormat));
};

/**
 * Получить разницу между двумя датами
 * @param {Date|number} dateFrom
 * @param {Date|number} dateTo
 * @param {string} [type]
 * @returns {Date|number}
 */
export const getDifferenceBetweenDateTypes = (dateFrom, dateTo, type = 'years') => {
  if (type === 'years') return differenceInYears(dateFrom, dateTo);
  if (type === 'months') return differenceInMonths(dateFrom, dateTo);
  if (type === 'days') return differenceInDays(dateFrom, dateTo);
  if (type === 'milliseconds') return differenceInMilliseconds(dateFrom, dateTo);
};
